import 'react/jsx-runtime';
import 'react';
import 'baseui';
import '../../../theme/olx-theme/base-theme.js';
import '../../../theme/olx-theme/theme.js';
import { styled } from '../../../theme/utils.js';
import '../../../theme/types.js';

const Wrapper = styled("div", () => ({
  position: "relative",
  display: "flex",
  flexDirection: "column"
}));
const StartEnhancerWrapper = styled("div", ({ $theme }) => ({
  display: "flex",
  alignItems: "center",
  left: $theme.space[16],
  pointerEvents: "none",
  position: "absolute",
  top: $theme.space[12]
}));
const EndEnhancerWrapper = styled("div", ({ $theme }) => ({
  display: "flex",
  alignItems: "center",
  pointerEvents: "none",
  position: "absolute",
  right: $theme.space[16],
  top: $theme.space[12]
}));

export { EndEnhancerWrapper, StartEnhancerWrapper, Wrapper };
